const secret = process.env.REACT_APP_API_KEY || "";

const encodeBase64UrlSafe = (input: string): string => {
  const combined = `${input}:${secret}`;
  const base64 = btoa(encodeURIComponent(combined));
  return base64
    .replace(/\+/g, "-") // replace + with -
    .replace(/\//g, "_") // replace / with _
    .replace(/=+$/, ""); // remove padding =
};

const decodeBase64UrlSafe = (input: string): string => {
  let base64 = input.replace(/-/g, "+").replace(/_/g, "/");
  while (base64.length % 4) base64 += "="; // restore padding
  const decoded = decodeURIComponent(atob(base64));
  const parts = decoded.split(":");
  if (parts.length !== 2 || parts[1] !== secret) {
    throw new Error("Invalid input or secret mismatch");
  }
  return parts[0];
};

const encodeBase64Number = (input: number): string => {
  return encodeBase64UrlSafe(input.toString());
};

const decodeBase64Number = (input: string): number => {
  const decodedString = decodeBase64UrlSafe(input);
  const parsedNumber = parseInt(decodedString, 10);
  if (isNaN(parsedNumber)) {
    throw new Error("Decoded value is not a valid number");
  }
  return parsedNumber;
};

export {
  encodeBase64UrlSafe as encodeBase64,
  decodeBase64UrlSafe as decodeBase64,
  encodeBase64Number,
  decodeBase64Number,
};
